export default "__VITE_ASSET__CaTq0QLc__"